import { EventEmitter, Injectable, Output } from '@angular/core';
import { ParentService } from '../A2-utils/ParentClass/ParentService';
import { Router } from '@angular/router';
import { Http, Response } from '@angular/http';
import { constant } from '../../app.constants';
import { TripStatusEnum } from 'app/core/enums/trips-status.enum';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

// Services
import { ReservationService } from '../trip-reservations/reservations.service';
import { ITripConfirm } from 'app/core/interfaces/ITripConfirm';
import { IResponseSuccess } from '../../core/interfaces/response.interface';
import { IDriverTrip } from 'app/core/interfaces/driver.interface';
import { ILateTrip } from 'app/core/interfaces/late-trip.interface';
import { ILinkedProvider, ITripDetail, ITripsGridData } from '../../core/interfaces/trip-detail.interface';
import { IVehicle } from 'app/core/interfaces/vehicle.interface';
import { ITripsByFiltersRequest } from 'app/core/interfaces/trips-by-filters-request.interface';


@Injectable()
export class DispatchService extends ParentService {

  @Output() reloadTripsOuput: EventEmitter<any> = new EventEmitter<any>();
  public pendingTripsSubject = new BehaviorSubject<any[]>([]);
  public tripsSubject = new BehaviorSubject<any[]>([]);
  public pendingTrips$ = this.pendingTripsSubject.asObservable();
  public trips$ = this.tripsSubject.asObservable();

  private allLoggedDrivers = new BehaviorSubject<IDriverTrip[]>([]);
  public allLoggedDrivers$ = this.allLoggedDrivers.asObservable();

  private driversIds = new BehaviorSubject<IDriverTrip[]>([]);
  public driversIds$ = this.driversIds.asObservable();

  private lateTripsSubject: Subject<ILateTrip[]> = new Subject();
  public lateTrips$: Observable<ILateTrip[]> = this.lateTripsSubject.asObservable();

  private updateGrid = new Subject<Boolean>();
  updateGrid$ = this.updateGrid.asObservable();

  private hasTripsSubject = new Subject<boolean>();
  hasTrips$ = this.hasTripsSubject.asObservable();

  private scheduledVehicles: Subject<IVehicle[]> = new Subject();
  public scheduledVehicles$: Observable<IVehicle[]> = this.scheduledVehicles.asObservable();

  public tripsValidStatus = [
    TripStatusEnum.Open,
    TripStatusEnum.Active,
    TripStatusEnum.Scheduled,
    TripStatusEnum.Accepted,
    TripStatusEnum.Hold,
  ];

  private selectedTripsSubject = new BehaviorSubject<ITripDetail[]>([]);
  selectedTrips$ = this.selectedTripsSubject.asObservable();

  private tripsIdSubject = new BehaviorSubject<ITripsGridData>({ tripsId: [], grid: null });
  tripsId$ = this.tripsIdSubject.asObservable();

  private tripsIdPendingSubject = new BehaviorSubject<ITripsGridData>({ tripsId: [], grid: null });
  tripsIdPending$ = this.tripsIdPendingSubject.asObservable();

  private listLinkedProviderSubject = new BehaviorSubject<ILinkedProvider[]>([]);
  listLinkedProvider$ = this.listLinkedProviderSubject.asObservable();

  private deleteTripsSubject$ = new BehaviorSubject<number[]>([]);
  deleteTrips$ = this.deleteTripsSubject$.asObservable();

  private unSelectSubject$ = new BehaviorSubject<number[]>([]);
  unSelect$ = this.unSelectSubject$.asObservable();

  private sendToClickedSubject$ = new Subject<{value: boolean, grid: number}>();
  sendToClicked$ = this.sendToClickedSubject$.asObservable();

  private selectedVehicle$ = new BehaviorSubject<string>(null);
  selectedVehicleChanges$ = this.selectedVehicle$.asObservable();

  private modalClosedSource$ = new Subject<boolean>();
  modalClosed$ = this.modalClosedSource$.asObservable();

  private closeAssignDriverModal$ = new Subject<boolean>();
  assignModalClosed$ = this.closeAssignDriverModal$.asObservable();

  private reloadCount = 0;
  private isReloadLoadingSubject = new BehaviorSubject<boolean>(true);
  public isReloadLoading$ = this.isReloadLoadingSubject.asObservable();

  constructor(private _http: Http, private route: Router, private service: ReservationService) {
    super();
    // this.verifyToken(this._http, route);
  }

  /**
   * @name
   * @description
   * @param {number} roleId
   */
  public getProviderForRole(roleId: number) {
    return this._http
      .get(constant.PROVIDER_ROLE_ACTIVE + roleId, this.getHeader())
      .map(res => res.json());
  }


  /**
   * @name getAssignedVehicles
   * @description
   * @param companyIds
   * @param date
   */
  public getAssignedVehicles(companyIds, date) {
    const data = {
      servicedate: date,
      companyIds: companyIds,
      listtype: 'TripsToDispatch'
    };
    const bodyString = JSON.stringify(data);
    const url = constant.URL_TRIP_SEARCH + '/TripsByVehicles';

    return this._http
      .post(url, bodyString, this.headerPost())
      .map(resp => resp.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  /**
   * @name getOnlineDriversOnDemand
   * @description
   */
  getOnlineDriversOnDemand(providerId) {
    return this._http
      .get(constant.URL_TRIP_SEARCH + `/TripsByVehiclesOnDemand/${providerId}`, this.getHeader())
      .map(resp => resp.json());
  }

  /**
   * @name getHistoryTrips
   * @description
   * @param request
   */
  getHistoryTrips(request: ITripsByFiltersRequest) {
    return this._http
      .post(`${constant.URL_TRIP_SEARCH}/TripsByFilters`, request, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  /**
   * @name getReportHistory
   * @description
   * @param providerid
   * @param dateStart
   * @param dateEnd
   */
  getReportHistory(providers, payors, dateStart, dateEnd, type) {
    const data = JSON.stringify({
      dateofservice: dateStart,
      dateofserviceend: dateEnd,
      payorids: payors,
      providerids: providers,
      type
    });

    return this._http
      .post(
        `${constant.URL_REPORT}/CreateHistoryReport`,
        data,
        this.getFileHeaders()
      )
      .catch((error: any) => Observable.throw(error.json()));
  }

  /**
   * @name getHistoryTrips
   * @description
   * @param providerid
   * @param dateStart
   * @param dateEnd
   */

  getTripsToConfirm(payload: ITripConfirm) {
    return this._http
      .post(
        `${constant.URL_TRIP_TO_CONFIRM}`,
        {
          date: payload.date,
          Payors: payload.payors,
          CallTypes: payload.callTypes,
          providers: payload.providers
        },
        this.headerPost()
      ).map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  updateTripsToConfirmed(payload: number[]): Observable<IResponseSuccess> {
    return this._http
      .patch(
        `${constant.URL_MASSIVE_TRIP_TO_CONFIRM}`,
        payload,
        this.headerPost()
      ).map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  /**
   * @name getAllTrips
   * @description
   * @param dateofservice
   * @param companyIds
   */
  getAllTrips(dateofservice, companyIds ? ) {

    const data = {
      servicedate: dateofservice,
      servicedateEnd: dateofservice,
      vehicles: [],
      companyIds: [companyIds],
      includeunassigned: true,
      listtype: 'AllTrips'
    };

    const stringData = JSON.stringify(data);
    const url = constant.URL_TRIP_SEARCH + '/List';
    return this._http
      .post(url, stringData, this.headerPost())
      .map(resp => resp.json());
  }

  public getTripsNoAcceptedByFilters(
    date: any,
    providerId?: number
  ) {
    return this._http
      .get(
        `${constant.URL_TRIP_SEARCH}/GetTripsNoAcceptedByFilters/${date}?providerId=${providerId}`,
        this.headerPost()
      ).map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

    public getAllTripsByFilters(
      date: any,
      providerId?: number,
      isSchedule?: boolean,
      showActive?: boolean,
      moduleactionid?: number,
      filterId?: number,
      depotIds?: number[]
    ) {
      const url = `${constant.URL_TRIP_SEARCH}/TripsByFilters`;
      const body = {
        dateOfService: date,
        providerId,
        isSchedule,
        showActive,
        moduleActionId: moduleactionid,
        filterId,
        depotIds: depotIds && depotIds.length ? depotIds : []
      };
      return this._http
        .post(
          url,
          body,
          this.headerPost()
        ).map((res: Response) => res.json())
        .catch((error: any) => Observable.throw(error.json()));
    }

  /**
   * @name formatTodayDate
   * @description
   */
  public formatTodayDate() {
    const
      d = new Date(),
      year = d.getFullYear();

    let
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate();


    if (month.length < 2) {
      month = '0' + month;
    }

    if (day.length < 2) {
      day = '0' + day;
    }

    return [year, month, day].join('-');
  }

  /**
   * @name getTripsDriversByFilters
   * @description
   * @param {string} date
   * @param {boolean} isSchedule
   * @param {number} providerid
   */
  public getTripsDriversByFilters(dateofservice: string, isschedule: boolean, companyid: number, depotids = [], orderby = 'Vehicle', createSchedule = false) {
    const body = JSON.stringify({
      dateofservice,
      companyid,
      depotids,
      isschedule,
      orderby,
      createSchedule
    })
    return this._http
      .post(`${constant.URL_TRIP_SEARCH}/TripsDriversByFilters`, body, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  joinLateTripsByProviderGroup(connectionId: string, providerId: number) {
    const options = this.headerPost();
    const url = `${constant.URL_HUB_LAST_TRIPS}/${connectionId}/${providerId}`;
    return this._http.post(url, {}, options);
  }

  leaveLateTripsByProviderGroup(connectionId: string, providerId: number) {
    const options = this.headerPost();
    const url = `${constant.URL_HUB_LAST_TRIPS}/${connectionId}/${providerId}`;
    return this._http.delete(url, options);
  }

  unsubscribeAndSubscribeToTripsByProviderGroup(connectionId: string, providerId: number, oldProviderId: number) {
    return this.leaveLateTripsByProviderGroup(connectionId, oldProviderId)
      .concatMap(_ => this.joinLateTripsByProviderGroup(connectionId, providerId))
      .catch(error => this.validate401Error(error, this.route));
  }

  /**
   * this join user to signal r
   */
  joinToSignalRGroup(connId, date, providerid) {
    return this._http.post(`${constant.URL_HUB_DISPATCH_GROUP}${connId}/${date}/${providerid}`, null, this.headerPost())
            .map(res => res.json())
            .catch(error => this.validate401Error(error, this.route))
  }

  deleteToSignalRGroup(connId, date, providerid) {
    return this._http.delete(`${constant.URL_HUB_DISPATCH_GROUP}${connId}/${date}/${providerid}`, this.headerPost())
      .map(res => res.json())
      .catch(error => this.validate401Error(error, this.route))
  }

  validateTimeExpired(data: any, pendingTripInterval: NodeJS.Timer, gridTrips: any) {
    if (pendingTripInterval) clearInterval(pendingTripInterval);
    if (!data) return;

    let checkArray = [];
    checkArray.push(...data);
    checkArray = checkArray.filter(({activationtime, activeexpiredminutes, tripstatusid}) => (activationtime && activeexpiredminutes && this.tripsValidStatus.includes(tripstatusid)));

    if (checkArray.length === 0) return;

    pendingTripInterval = setInterval(() => {
      const isOneExpired = checkArray.some(({activationtime, activeexpiredminutes}) => this._isExpiredTrip(new Date(), activationtime, activeexpiredminutes));
      if (isOneExpired) gridTrips.api.refreshView();
    }, 60000);
  }

  /**
   * @name _isExpiredTrip
   * @description Check if 30 minutes have passed between two dates
   * @param currentTime
   * @param activationTime
   * @param activeExpiredMinutes
   * @returns {boolean}
   */
  private _isExpiredTrip(currentTime: Date, activationTime: string, activeExpiredMinutes: number): boolean {
    if (!activationTime || !activeExpiredMinutes) return false;
    // Parse activation time from string to date
    const activationTimeDate = new Date(activationTime);

    const diff = Math.abs(currentTime.getTime() - activationTimeDate.getTime());
    const diffMinutes = Math.floor((diff / 1000) / 60);
    return diffMinutes >= activeExpiredMinutes;
  }

  /**
   * @name rowClassFunction
   * @description Function to apply row class
   * @param {any} data
   * @param {number} timeServer
   * @param {Array<Subscription>} observables
   * @returns {boolean}
   */
  rowClassFunction(data) {
    const {activationtime, activeexpiredminutes, tripstatusid} = data;
    if (!activationtime || !activeexpiredminutes || !this.tripsValidStatus.includes(tripstatusid)) return false;
    return this._isExpiredTrip(new Date(), activationtime, activeexpiredminutes);
  }

  setAllLoggedDrivers(drivers: IDriverTrip[]) {
    this.allLoggedDrivers.next(drivers);
  }

  setDriversIds(driversIds: IDriverTrip[]) {
    this.driversIds.next(driversIds);
  }

  sendLateTrips(lateTrips: ILateTrip []): void {
    this.lateTripsSubject.next(lateTrips);
  }

  updateSelectedTrips(trips: ITripDetail[]) {
    this.selectedTripsSubject.next(trips);
  }

  updateTripsid(data: ITripsGridData) {
    this.tripsIdSubject.next(data);
  }

  updateListLinkedProvider(providers: ILinkedProvider[]) {
    this.listLinkedProviderSubject.next(providers);
  }

  emitDeleteTrips(tripsid: number[]) {
    this.deleteTripsSubject$.next(tripsid);
  }

  emitUnselect(tripSelected: number[]) {
    this.unSelectSubject$.next(tripSelected);
  }

  emitSendToClicked(value: boolean, grid: number) {
    this.sendToClickedSubject$.next({value, grid});
  }

  updateTripsPending(data: ITripsGridData) {
    this.tripsIdPendingSubject.next(data);
  }

  setNotifyUpdateGrid(value: Boolean): void {
    this.updateGrid.next(value);
  }

  setSelectedVehicle(vehicleCode: string): void {
    this.selectedVehicle$.next(vehicleCode);
  }

  notifyModalClosed(value: boolean): void {
    this.modalClosedSource$.next(value);
  }

  closeAssignDriverModal(value: boolean ){
    this.closeAssignDriverModal$.next(value);
  }

  setHasTrips(value: boolean): void {
    this.hasTripsSubject.next(value);
  }

  sendScheduledVehicles(vehicles: IVehicle[]): void {
    const clone = vehicles.map(v => Object.assign({}, v));
    this.scheduledVehicles.next(clone);
  }

  setReloadLoading(loading: boolean): void {
    this.reloadCount += loading ? 1 : -1;
    if (this.reloadCount < 0) {
      this.reloadCount = 0;
    }
    this.isReloadLoadingSubject.next(this.reloadCount > 0);
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/dispatch/dispatch.service.ts